import { ContributionDay } from '../types/profile.types';

export const generateYearContributions = (
	year: number = new Date().getFullYear()
): ContributionDay[] => {
	const contributions: ContributionDay[] = [];
	const startDate = new Date(year, 0, 1);
	const endDate = new Date(year, 11, 31);

	for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
		const randomCount = Math.floor(Math.random() * 20);
		let level: 0 | 1 | 2 | 3 | 4 = 0;

		if (randomCount === 0) level = 0;
		else if (randomCount <= 5) level = 1;
		else if (randomCount <= 10) level = 2;
		else if (randomCount <= 15) level = 3;
		else level = 4;

		contributions.push({
			date: new Date(date).toISOString().split('T')[0],
			count: randomCount,
			level,
		});
	}

	return contributions;
};

export const calculateTotalContributions = (contributions: ContributionDay[]): number => {
	return contributions.reduce((sum, day) => sum + day.count, 0);
};

export const getContributionLevel = (count: number): 0 | 1 | 2 | 3 | 4 => {
	if (count === 0) return 0;
	if (count <= 5) return 1;
	if (count <= 10) return 2;
	if (count <= 15) return 3;
	return 4;
};

export const getLevelClass = (level: number, styles: Record<string, string>) => {
	if (level === 1) return styles.dayLevel1;
	if (level === 2) return styles.dayLevel2;
	if (level >= 3) return styles.dayLevel3;
	return styles.dayLevel0;
};

export const groupContributionsByMonth = (contributions: ContributionDay[]) => {
	const monthsMap: Record<number, ContributionDay[]> = {};
	for (let i = 0; i < 12; i++) monthsMap[i] = [];

	contributions.forEach((day) => {
		const date = new Date(day.date + 'T00:00:00');
		const monthIndex = date.getMonth();
		if (monthsMap[monthIndex]) monthsMap[monthIndex].push(day);
	});
	return monthsMap;
};
